export default "__VITE_ASSET__c0a01714__"